/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ ids: NonNullable<unknown> }} Settings_Currently_SyncingInputs */

const en_settings_currently_syncing = /** @type {(inputs: Settings_Currently_SyncingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Currently syncing: ${i?.ids}`)
};

const he_settings_currently_syncing = /** @type {(inputs: Settings_Currently_SyncingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`מסונכרן כעת: ${i?.ids}`)
};

/**
* | output |
* | --- |
* | "Currently syncing: {ids}" |
*
* @param {Settings_Currently_SyncingInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const settings_currently_syncing = /** @type {((inputs: Settings_Currently_SyncingInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Currently_SyncingInputs, { locale?: "en" | "he" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_currently_syncing(inputs)
	return he_settings_currently_syncing(inputs)
});